/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_F3_DescInputs */

const en_landing_features_f3_desc = /** @type {(inputs: Landing_Features_F3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paint a mask over the part to change and describe the edit. Unpainted pixels are locked, and with Pixel Lock they are copied back from your source, so nothing outside the brush can move.`)
};

const zh_landing_features_f3_desc = /** @type {(inputs: Landing_Features_F3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在需要修改的部分涂抹遮罩并描述修改。未涂抹的像素全部锁定，开启像素锁定后会从原图拷回，笔刷之外什么都不会动。`)
};

/**
* | output |
* | --- |
* | "Paint a mask over the part to change and describe the edit. Unpainted pixels are locked, and with Pixel Lock they are copied back from your source, so nothin..." |
*
* @param {Landing_Features_F3_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_f3_desc = /** @type {((inputs?: Landing_Features_F3_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_F3_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_f3_desc(inputs)
	return zh_landing_features_f3_desc(inputs)
});
export { landing_features_f3_desc as "landing.features.f3_desc" }